import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export function ProtectedRoute({ role, children }) {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div className="flex min-h-screen items-center justify-center" data-testid="auth-loading">
                <div className="flex items-center gap-3 text-slate-500">
                    <span className="h-2 w-2 rounded-full bg-civic-600 animate-pulse-soft" />
                    <span className="font-mono text-sm">verifying credentials…</span>
                </div>
            </div>
        );
    }
    if (!user) return <Navigate to={role === "admin" ? "/login/admin" : "/login/voter"} replace />;
    if (role && user.role !== role) return <Navigate to="/" replace />;
    return children;
}
